import React from 'react'
import styled from 'styled-components/macro'
import { em } from '../../../utils/styles'
import Button from '../../Button'

export const FormActionWrapper = styled.div`
  margin: ${em(40)} 0 0;
  text-align: center;
`

function FormAction(props) {
  return (
    <FormActionWrapper>
      <Button type='submit' {...props} />
    </FormActionWrapper>
  )
}

export default FormAction
